let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("6ACCg"), load("ffEVr"), load("7jSfd")]).then(() => parcelRequire('h45kr'));